import { Component, model, output, signal, viewChild } from '@angular/core';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CustomValidators, FormDisplayControl } from '@oi-soft/common';
import { FormControlUnderlineComponent } from '@shared/components/form/form-control/form-control-types/form-control-underline/form-control-underline.component';
import { ModalComponent } from '@shared/components/modals/modal/modal.component';
import { Subscription } from 'rxjs';
import { FormControlComponent } from "../../../../shared/components/form/form-control/form-control.component";
import { ModalFormButtonGroupComponent } from "../../../../shared/components/modals/modal/modal-button-group/modal-form-button-group/modal-form-button-group.component";
import { TabNavigationComponent } from "../../../../shared/components/tab-navigation/tab-navigation.component";
import { TabPanelComponent } from "../../../../shared/components/tab-navigation/tab-panel/tab-panel.component";

@Component({
    selector: 'app-login-tfa-modal',
    imports: [FontAwesomeModule, ModalComponent, FormControlUnderlineComponent, ReactiveFormsModule, FormControlComponent, ModalFormButtonGroupComponent, TabNavigationComponent, TabPanelComponent],
    templateUrl: './login-tfa-modal.component.html',
    styleUrl: './login-tfa-modal.component.scss'
})
export class LoginTFAModalComponent {

    tokenUnderlineControl = viewChild(FormControlUnderlineComponent);
    
    visible = model<boolean>(false);

    login = output<{token?:string, recovery?:string}>();

    panels = signal<string[]>(['token','recovery']);
    
    subscriptions:Subscription[] = [];
    
    form = new FormGroup({
        token: new FormDisplayControl(
            'Token', '',
            {
                validators: [Validators.required, CustomValidators.numeric, Validators.minLength(6), Validators.maxLength(6)],
            }
        ),
        recovery: new FormDisplayControl(
            'Recovery Code', '',
            {
                validators: [Validators.required],
            }
        ),
    });

    constructor(){

        this.form.controls.token.valueChanges.subscribe({
            next:(value) => {
                if(value && value.length == 6){
                    this.onSubmit();
                }
            },
        })

    }
    
    onSubmit(){
        
        if(this.form.controls.token.valid || this.form.controls.recovery.valid){
            this.login.emit({
                token: this.form.controls.token.value,
                recovery: this.form.controls.recovery.value
            });
        }
        
    }

    onOpened(){
        this.tokenUnderlineControl()?.inputFields().at(0)?.nativeElement.focus();
    }

    onClosed(){
        this.form.reset();
    }
    
}
